<template>
  <div>
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Terms and Conditions</span>
    </v-row>

    <v-row no-gutters class="mt-2">
      <span class="body-2">
        <a target="_blank" href="https://www.parish-online.co.uk/forms/terms/Parish-Online-Terms-and-Conditions.pdf">Click here to view our Terms and Conditions >></a>
      </span>
    </v-row>

    <v-row no-gutters class="mt-2 pl-4">
      <v-checkbox v-model="acceptTerms"
                  color="info"
                  label="I accept the terms and conditions for Parish Online"
      ></v-checkbox>
    </v-row>

    <v-row no-gutters class="mt-n4 pl-4">
      <v-checkbox v-model="emailConfirm"
                  color="info"
                  label="I would like to receive information by email regarding software updates, tips, tricks and news relating to Parish Online"
      ></v-checkbox>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <span class="body-2">How did you hear about us?</span>
        <v-row>
          <v-col>
            <v-select outlined dense hide-details
                      v-model="hearAboutUs"
                      placeholder="Choose a method..."
                      :items="hearAboutUsItems"
                      :menu-props="{ overflowY: true, offsetY: true }"
            ></v-select>
          </v-col>
          <v-col>
            <div no-gutters v-if="hearAboutUs === 'Other'">
              <v-text-field outlined dense hide-details
                            v-model="hearAboutUsOther"
                            placeholder="Please let us know:"
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-4">
      <span v-if="isAllValid" class="body-2">Click "Next" to continue the signup process.</span>
      <span v-else class="body-2 font-weight-medium" style="color: #BF1722">You must accept the terms and conditions to continue.</span>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "StepEight",
    components: {},
    props: {
      valid: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        acceptTerms: false,
        emailConfirm: false,
        hearAboutUsOther: '',
        hearAboutUs: '',
        hearAboutUsItems: [
          'Previous Customer',
          'Suggested by a colleague',
          'Suggested by another Parish',
          'Suggested by a District or County',
          'Suggested by Ordnance Survey',
          'Through BHIB Council Insurance deal',
          'Suggested by NALC',
          'Suggested by County ALC',
          'Found through web search',
          'Saw social media post',
          'Read newsletter',
          'Other'
        ],
      }
    },
    computed: {
      isAllValid() {
        let valid = this.acceptTerms;
        this.$emit('update:valid', valid);
        if (valid) {
          this.$store.commit('SET_ADDITIONAL_DETAILS', {
            termsAccepted: this.acceptTerms,
            emailConfirm: this.emailConfirm,
            hearAboutUs: this.hearAboutUs === 'Other' ? (this.hearAboutUs + ' - ' + this.hearAboutUsOther) : this.hearAboutUs,
          });
        }
        return valid;
      },
    },
    methods: {}
  }
</script>
